import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromAppRoot from '@app/app.reducers';

@Injectable({
  providedIn: 'root'
})
class Already3bNotAllowedGuardService {
  protected readonly onDestroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private store: Store
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Observable((observer) => {
      this.store
        .pipe(takeUntil(this.onDestroy$))
        .pipe(select(fromAppRoot.selectCustomerAndCurrentInvestAccount))
        .subscribe((value) => {
          if (!value || !value.customer || !value.customer.email) {
            return;
          }
          const hasAccount = value.customer.accounts.filter((account) => account.kind === '3b').length > 0;
          const isNotGrow = route.params['kind'] !== 'grow';
          if (value.currentAccountDetail?.kind === '3a' && hasAccount && isNotGrow) {
            observer.next(this.router.parseUrl('/'));
          } else {
            observer.next(true);
          }
          this.onDestroy$.next();
          this.onDestroy$.complete();
        });
    });
  }
}

export const Already3bNotAllowedGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  return inject(Already3bNotAllowedGuardService).canActivate(route);
};
